import { Chip } from "@components/ui/Chip"
import { Link } from "eddev/routing"
import { useTFFLocationsByState } from "./useTFFLocations"
import { Button } from "@components/ui/Button"

export function TFFMegaMenu() {
  const locations = useTFFLocationsByState()

  return (
    <div className="grid-auto relative">
      <div className="col-span-12 md:col-span-9 grid-auto">
        {locations.map((state) => {
          return (
            <div key={state.state} className="col-span-12 md:col-span-3 py-5">
              <h4 className="type-label-caps text-fg-secondary mb-3">{state.stateLabel}</h4>
              <div className="flex flex-col group">
                {state.locations.map((location) => (
                  <Link
                    href={location.uri}
                    className="flex gap-3 type-ui-l py-2 hover:!opacity-100 group-has-[a:hover]:opacity-80 transition-opacity"
                    key={location.uri}
                  >
                    <div className="text-fg">{location.title}</div>

                    {location.status.saleStatusLabel && (
                      <Chip shape="rounded" variant={location.status.onSale ? "hero" : "mid"}>
                        {location.status.saleStatusLabel}
                      </Chip>
                    )}
                  </Link>
                ))}
              </div>
            </div>
          )
        })}
      </div>
      <div className="hidden bg-bg-mid col-span-3 -mr-grid-margin-full md:flex flex-col gap-6 justify-between p-5">
        <p className="type-title-l text-pretty">Looking for Sydney Film Festival?</p>
        <div>
          <Button href="/" variant="primary" shape="branded" rightIcon="chevronRight">
            Back to SFF
          </Button>
        </div>
      </div>
    </div>
  )
}
